import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { ITextChatMessage } from '@bcl/chat';
import { IFileChatMessage } from '@bcl/chat/lib/file-messages';
import { UserChatMessage } from '../chat.model';
import { AttachmentsService } from '../../../../services/attachments.service';
import { ReplaySubject, takeUntil } from 'rxjs';
import { ComponentChanges, SnackbarService } from '@bcl/design-system';
import { getMimeTypeIconUrl, isImage } from '../../../../core/mime-types';
import { environment } from 'src/environments/environment';
import { DocumentsListApiService } from '../../../../pages/visit-day-details/components/visit-documents/visit-documents.service';

@Component({
  selector: 'pc-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
})
export class ChatMessageComponent
  implements OnChanges, AfterViewInit, OnDestroy
{
  @Input()
  public message!: UserChatMessage;
  @Input()
  public currentUserId: string | undefined;

  @Output()
  public messageInitialized = new EventEmitter<void>();

  public mimeTypeIconUrl: string | undefined;
  public imageUrl: string | undefined;
  public downloading = false;
  public readonly globalDateFormatWithTime =
    environment.globalDateFormatWithTime;

  private readonly destroyed$ = new ReplaySubject<void>(1);

  constructor(
    private fileService: AttachmentsService,
    private documentsApiService: DocumentsListApiService,
    private snackbarService: SnackbarService
  ) {}

  public readonly textMessageGuard = (_: unknown): _ is ITextChatMessage =>
    true;
  public readonly fileMessageGuard = (_: unknown): _ is IFileChatMessage =>
    true;

  public ngOnChanges(changes: ComponentChanges<ChatMessageComponent>): void {
    if (changes.message) {
      if (changes.message.currentValue.content?.type === 'file') {
        const fileMessage = changes.message.currentValue
          .content as IFileChatMessage;
        this.mimeTypeIconUrl = getMimeTypeIconUrl(fileMessage.mimeType);
        this.imageUrl = isImage(fileMessage.mimeType)
          ? this.fileService.getFileUrl(fileMessage.fileReferenceNumber)
          : undefined;
      } else {
        this.imageUrl = undefined;
      }
    }
  }

  public ngAfterViewInit(): void {
    this.messageInitialized.emit();
  }

  public downloadFile(fileReferenceNumber: string, fileName: string): void {
    this.downloading = true;

    this.documentsApiService
      .downloadFile(fileReferenceNumber)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (blob) => {
          this.documentsApiService.downloadFileToDisk(blob, fileName);

          this.snackbarService.open(
            'green',
            'DOCUMENTS_LIST.MESSAGES.DOWNLOAD_DOCUMENT_SUCCESS'
          );

          this.downloading = false;
        },
        error: () => {
          this.snackbarService.open(
            'red',
            'DOCUMENTS_LIST.MESSAGES.DOWNLOAD_DOCUMENT_ERROR'
          );
          this.downloading = false;
        },
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
